/**
 * Storage Service for Editor
 * 캔버스 이미지를 Firebase Storage에 업로드하고 base64를 URL로 교체
 */
import { storage } from '../../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const dataURLtoBlob = (dataURL) => {
  const [header, data] = dataURL.split(',');
  const mime = header.match(/:(.*?);/)[1];
  const binary = atob(data);
  const array = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    array[i] = binary.charCodeAt(i);
  }
  return new Blob([array], { type: mime });
};

const uploadImageToStorage = async (base64DataURL, storagePath) => {
  const blob = dataURLtoBlob(base64DataURL);
  const storageRef = ref(storage, storagePath);
  await uploadBytes(storageRef, blob, { contentType: blob.type });
  return await getDownloadURL(storageRef);
};

/**
 * canvasState JSON 내의 base64 이미지를 Storage에 업로드하고 URL로 교체
 */
export const uploadCanvasImages = async (canvasStateJSON, projectId, slideIndex) => {
  if (!canvasStateJSON) return canvasStateJSON;

  const state = JSON.parse(canvasStateJSON);
  if (!state.objects || state.objects.length === 0) return canvasStateJSON;

  let imageCount = 0;

  const processObject = async (obj) => {
    if (obj.type?.toLowerCase() === 'image' && obj.src && obj.src.startsWith('data:')) {
      const imageId = `img_${imageCount++}_${Date.now()}`;
      const storagePath = `editor_projects/${projectId}/${String(slideIndex).padStart(5, '0')}/${imageId}.png`;
      try {
        obj.src = await uploadImageToStorage(obj.src, storagePath);
      } catch (err) {
        console.error('이미지 업로드 실패:', storagePath, err);
      }
    }
    if (obj.objects && Array.isArray(obj.objects)) {
      for (const child of obj.objects) {
        await processObject(child);
      }
    }
  };

  for (const obj of state.objects) {
    await processObject(obj);
  }

  return JSON.stringify(state);
};
